import { render } from "./BourseDossardsList.vue?vue&type=template&id=1b4b9204"
import script from "./BourseDossardsList.vue?vue&type=script&lang=js"
export * from "./BourseDossardsList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__